<template lang="html">
<div class="map-context-menu">
    <v-card>
        <v-card-title class="primary white--text pa-2 pl-3 spaced">
            <h3 class="title">Coordinates</h3>
            <v-btn @click="$emit('close')" flat icon class="primary right close-button ma-0 pa-0">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="text-xs-center">
            <input
            @click="({target}) => target.select()"
            readonly
            class="subheading text-xs-center"
            id="click-coordinates"
            ref="click-coordinates"
            type="text"
            :value="displayCoords">
        </v-card-text>
        <v-card-actions>
            <v-btn flat @click="copyCoordinates" color="primary">Copy to clipboard</v-btn>
        </v-card-actions>
    </v-card>
</div>
</template>

<script>
import * as actions from '@/constants/actions';

export default {
    name: 'map-context-menu',
    props: [
        'lngLat',
    ],
    computed: {
        coords() {
            return this.lngLat.toArray();
        },
        lng() {
            return this.coords[0];
        },
        lat() {
            return this.coords[1];
        },
        displayCoords() {
            // use filter function
            const numFormat = this.$options.filters.numFormat;
            const lat = numFormat(this.lat, '0.00000');
            const lng = numFormat(this.lng, '0.00000');
            return `${lat}, ${lng}`;
        },
    },
    methods: {
        copyCoordinates() {
            const coordsField = this.$refs['click-coordinates'];
            coordsField.select();
            document.execCommand('Copy');
            // clear selection
            document.getSelection().removeAllRanges();

            // notify user that text was copied
            this.$store.dispatch(actions.TRIGGER_TOAST, 'Copied coordinates to clipboard');
        },
    },
};
</script>

<style lang="scss">
.map-context-menu {
    min-width: 15rem;

    // show on top of .card
    .close-button {
        z-index: 1;
    }
    .spaced {
        justify-content: space-between;
    }
}
// want the arrow on top to be a different colour? uncomment this.
// .mapboxgl-popup-anchor-top, .mapboxgl-popup-anchor-top-left, .mapboxgl-popup-anchor-top-right {
//     .mapboxgl-popup-tip {
//         border-bottom-color: #3f51b5;
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/MapContextMenu.vue